import React from 'react';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Divider, Input, InputNumber, Row } from 'antd';

export default function PickupLocation({ Form }) {
	return (
		<Form.List name='defaultPickuplocation'>
			{(fields, { add, remove }) => (
				<>
					{fields.map(({ key, name }) => (
						<Row gutter={[16, 0]} key={key}>
							<Col sm={24} md={6}>
								<Form.Item label='Pickup Location' name={[name, 'pickupLocation']}>
									<Input placeholder='Select Pickup Location' autoFocus />
								</Form.Item>
							</Col>

							{/* <Col sm={24} md={7}>
								<Form.Item
									label='Start & End Date/Time'
									name={[name, 'pickupStartEndDateTime']}
									rules={[
										{
											required: true,
											message: 'Batch Start & End Date/Time is required',
										},
									]}
								>
									<DatePicker.RangePicker showTime />
								</Form.Item>
							</Col> */}

							<Col sm={24} md={1}>
								{fields.length > 1 ? (
									<Form.Item label='&nbsp;'>
										<Button icon={<CloseOutlined />} shape='circle' onClick={() => remove(name)} />
									</Form.Item>
								) : null}
							</Col>
							<Divider style={{ margin: 0, marginBottom: 16 }} />
						</Row>
					))}
					<Row gutter={[16, 0]}>
						<Col sm={24} md={6}>
							<Form.Item>
								<Button
									icon={<PlusOutlined />}
									type='primary'
									onClick={() => {
										add();
									}}
									style={{ width: '100%' }}
								>
									Add Pickup Location
								</Button>
							</Form.Item>
						</Col>
					</Row>
				</>
			)}
		</Form.List>
	);
}
